import { render } from "./CarPolicy.vue?vue&type=template&id=15db1439&scoped=true"
import script from "./CarPolicy.vue?vue&type=script&lang=ts"
export * from "./CarPolicy.vue?vue&type=script&lang=ts"

import "./CarPolicy.vue?vue&type=style&index=0&id=15db1439&lang=sass&scoped=true"
import "./CarPolicy.vue?vue&type=style&index=1&id=15db1439&lang=sass"
script.render = render
script.__scopeId = "data-v-15db1439"

export default script